module.exports = __webpack_public_path__ + "img/plant.c7a50408.svg";